import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { todayISO } from '../utils/flights.js';

const HERO_BG = `${import.meta.env.BASE_URL}assets/airport-exterior-view.jpg?v=202607242350`;

export default function FlightSearch() {
  const navigate = useNavigate();
  const [dir, setDir] = useState('arr');
  const [q, setQ] = useState('');
  const [city, setCity] = useState('');
  const [date, setDate] = useState(todayISO());

  const onSubmit = (e) => {
    e.preventDefault();
    const params = new URLSearchParams();
    params.set('dir', dir);
    if (q.trim()) params.set('q', q.trim());
    if (city.trim()) params.set('city', city.trim());
    if (date) params.set('date', date);
    navigate(`/flights?${params.toString()}#flights-board`);
  };

  return (
    <section className="v4-hero-bg relative flex min-h-[100svh] flex-col overflow-hidden">
      <img
        src={HERO_BG}
        alt=""
        className="pointer-events-none absolute inset-0 h-full w-full object-cover"
        width={1920}
        height={1080}
        fetchPriority="high"
        decoding="async"
      />
      <div
        className="pointer-events-none absolute inset-0"
        style={{
          background:
            'linear-gradient(120deg, rgba(10, 42, 92, 0.72) 0%, rgba(15, 62, 138, 0.45) 42%, rgba(10, 42, 92, 0.25) 100%)',
        }}
        aria-hidden="true"
      />

      <div className="relative mx-auto flex w-full max-w-7xl flex-1 flex-col px-4 pt-16 sm:px-6 sm:pt-20 lg:px-8 lg:pt-50">
        <div className="max-w-3xl pb-10">
          <p className="mb-4 inline-flex rounded-full border border-white/25 bg-white/10 px-3 py-1 text-xs font-semibold uppercase tracking-[0.18em] text-white/90 backdrop-blur">
            Welcome
          </p>
          <h1 className="v4-hero-title">Welcome to Nouakchott Airport</h1>
          <p className="mt-5 max-w-xl text-base leading-relaxed text-white/85 sm:text-lg">
            Your gateway where the Sahara meets the Atlantic, live flights in GMT, seamless passenger
            services, and a premium journey through Mauritania.
          </p>
        </div>

        <div className="v4-hero-bottom mt-auto w-full">
          <form className="v4-flight-search" onSubmit={onSubmit} role="search" aria-label="Flight search">
            <div className="v4-flight-search__head">
              <h2 className="font-display text-lg font-bold text-nkc-navy">Search flights</h2>
              <div className="inline-flex rounded-full bg-nkc-mist p-1" role="tablist" aria-label="Direction">
                {[
                  { id: 'arr', label: 'Arrival' },
                  { id: 'dep', label: 'Departure' },
                ].map((tab) => (
                  <button
                    key={tab.id}
                    type="button"
                    className={`v4-tab rounded-full px-4 py-2 text-sm font-semibold${dir === tab.id ? ' is-active text-white' : ' text-nkc-muted'}`}
                    role="tab"
                    aria-selected={dir === tab.id}
                    onClick={() => setDir(tab.id)}
                  >
                    {tab.label}
                  </button>
                ))}
              </div>
            </div>

            <div className="v4-flight-search__row">
              <label className="block min-w-0">
                <span className="v4-flight-search__label">Flight number</span>
                <input
                  type="search"
                  placeholder="e.g. L6 146"
                  className="v4-flight-search__input"
                  value={q}
                  onChange={(e) => setQ(e.target.value)}
                />
              </label>
              <label className="block min-w-0">
                <span className="v4-flight-search__label">Destination / city</span>
                <input
                  type="text"
                  placeholder="City or airport"
                  className="v4-flight-search__input"
                  value={city}
                  onChange={(e) => setCity(e.target.value)}
                />
              </label>
              <label className="block min-w-0">
                <span className="v4-flight-search__label">Date</span>
                <input
                  type="date"
                  className="v4-flight-search__input"
                  value={date}
                  onChange={(e) => setDate(e.target.value)}
                />
              </label>
              <div className="flex items-end">
                <button type="submit" className="v4-flight-search__btn">
                  Search
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>

      <Link to="/business-opportunities" className="v4-hero-ad">
        <span className="v4-hero-ad__title">Maintenance as a Service</span>
        <span className="v4-hero-ad__text">End-to-end upkeep for terminal systems, airside assets &amp; facilities</span>
        <span className="v4-hero-ad__cta">Explore MaaS options</span>
      </Link>
    </section>
  );
}
